(function(exports)
{
  exports.data = exports.data || {}

  // Global challenge status
  exports.challengeStatus = 'new'
  exports.stepCount = 0

  // CO2 Emission data fixtures for Sweden and the world; taken from http://data.worldbank.org
  exports.data.co2Emissions =
  [[
    5.52862826872355,
    5.66312437439099,
    5.66053901186304,
    5.68293374487378,
    5.69308804241805,
    5.64504101664953,
    5.8047541398111,
    5.88435049763087,
    5.87633903026625,
    6.03619519225582,
    6.0980441800285,
    6.13913426216307,
    6.32655154624309,
    6.39842667349654,
    6.38992818816225,
    6.09800747870118,
    6.33155993014971,
    6.28170571122958,
    6.57378419328715,
    6.41430341309402
  ], [
    6.25174629259818,
    6.24852477172438,
    6.32403140459934,
    5.89509851954463,
    5.98545979233472,
    5.76966651365779,
    5.56243008285854,
    5.74702606576468,
    6.43422859805055,
    6.11519453231213,
    6.06224140440501,
    5.71031351209116,
    5.45900321623082,
    5.25352193659618,
    5.32809827545271,
    4.63141135977089,
    5.54734805226545,
    5.47495712076762,
    4.94230082776452,
    4.61718188417353
  ]]

  exports.data.result =
  [
    [exports.data.co2Emissions[0][19]],
    [exports.data.co2Emissions[1][19]],
    [(exports.data.co2Emissions[1][19] / 2)],
  ]
})(window)
